import * as StateLib from "@/Utils/StateLib";
import React, { Fragment, useRef } from "react";
import { HorizontalToolbar, Divider, ColorTrigger } from "@theorgchartdev/storybook";
import BoxFormatToolsComposite from "./BoxFormatToolsComposite/BoxFormatToolsComposite";
import TextFormatToolsComposite from "./TextFormatToolsComposite/TextFormatToolsComposite";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { GetToolbarStyle, RenderToolbarContent } from "./ContextualToolbar";
import CompositeColorPicker from "../../Blocks/Composites/CompositeColorPicker/CompositeColorPicker";
import ArrangeToolsComposite from "./ArrangeToolsComposite/ArrangeToolsComposite";
import { getHoverTipContent } from "@/Utils/Misc";
import { PhotoCellToolsComposite } from "@/appComponents/Navigation/ContextualToolbar/PhotoCellToolsComposite/PhotoCellToolsComposite";
import BackgroundToolsComposite from "@/appComponents/Navigation/ContextualToolbar/BackgroundToolsComposite/BackgroundToolsComposite";
import { encodeColorObject } from "@/appComponents/Blocks/Composites/CompositeColorPicker/ColorPicker.utils";
import { enumFillMode, enumChartElement } from "@coreapp/constants";
import { Globals } from "@coreapp/CoreApp/Globals";

const dividerClass = "ocn-toolbar-horizontal-divider";

const UpdateBackgroundColor = selectedColor => {
  const wsMgr = StateLib.GetWSMgr();
  if (!wsMgr) return;
  var scMgr = wsMgr.GetSubChartMgr();
  var docMgr = wsMgr.GetDocMgr();
  wsMgr.StartCheckPoint();
  var curDoc = wsMgr.GetDoc();
  var pageMgr = curDoc.GetPageMgr();
  pageMgr.JournalPageProps();
  let mode = enumFillMode.solidFill;
  let backgroundColor1 = "#FFFFFF";
  let backgroundColor2 = "#FFFFFF";
  if (Array.isArray(selectedColor)) {
    backgroundColor1 = selectedColor[0];
    backgroundColor2 = selectedColor[1];
    mode = enumFillMode.linearGradientDown;
  } else if (selectedColor) {
    backgroundColor1 = selectedColor;
  }
  docMgr.SetBackgroundColor(backgroundColor1);
  docMgr.SetBackgroundColor2(backgroundColor2);
  docMgr.SetBackgroundFillMode(mode);
  wsMgr.fBackgroundMgr?.fActiveBackgroundArea?.SetPageProps(pageMgr?.GetPageProps());
  wsMgr.fBackgroundMgr?.SignalActiveBackgroundChanged();
  if (wsMgr.fCanvasPanel) wsMgr.fCanvasPanel.ClearGradientCache();
  wsMgr.EndCheckPoint();
  StateLib.ReRenderCanvas();
};

const ContextualToolbarEditBackground = () => {
  const { wsMgr } = useWSMgrContext();
  const fillColorOpenCtrlRef = useRef(null);
  const workspaceMgr = StateLib.GetWSMgr();
  let firstSelectedBox = null;
  let firstSelectedCell = null;
  let isPicture = false;
  if (workspaceMgr) {
    firstSelectedBox = workspaceMgr.GetFirstSelectedBox(true);
    if (firstSelectedBox) isPicture = firstSelectedBox.IsStaticPicture(); // && !roMode
    firstSelectedCell = workspaceMgr.GetFirstSelectedElement(enumChartElement.boxCell);
  }
  let primaryFill;
  let secondaryFill;
  let fm = enumFillMode.solidFill;
  if (workspaceMgr && workspaceMgr.GetDocMgr()) {
    const dm = workspaceMgr.GetDocMgr();
    primaryFill = dm.GetBackgroundColor();
    secondaryFill = dm.GetBackgroundColor2();
    if (secondaryFill === "#FFFFFF") {
      secondaryFill = null;
    }
    fm = dm.GetBackgroundFillMode();
  }

  const leftContent = (
    <Fragment>
      <CompositeColorPicker
        openCtrlRef={fillColorOpenCtrlRef}
        dataTestId="background-editor-toolbar-fill-color"
        trigger={
          <ColorTrigger
            iconName="fill-drip"
            size={"small"}
            tooltipProps={{
              ...getHoverTipContent("masterbkgrnd"),
              referenceOpenCtrlRef: fillColorOpenCtrlRef
            }}
          />
        }
        onChange={UpdateBackgroundColor}
        showGradient
        currentColor={encodeColorObject(primaryFill, secondaryFill)}
      />
      <div className={dividerClass}>
        <Divider vertical={true} />
      </div>
      {(firstSelectedBox || firstSelectedCell) && (
        <Fragment>
          {firstSelectedBox && (
            <Fragment>
              <BackgroundToolsComposite />
              <ArrangeToolsComposite />
              {!isPicture && (
                <Fragment>
                  <BoxFormatToolsComposite />
                  <div className={dividerClass}>
                    <Divider vertical={true} />
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
          {!isPicture && (
            <Fragment>
              <TextFormatToolsComposite
                showFieldDisplay={!Globals._uiConfig.fBLEHoverBarEnabled}
                dataTestIdPrefix={"ctx-toolbar-bg"}
              />
              <div className={dividerClass}>
                <Divider vertical={true} />
              </div>
            </Fragment>
          )}
          {firstSelectedCell && (
            <PhotoCellToolsComposite dataTestIdPrefix="background-editor-ctx-toolbar-" />
          )}
        </Fragment>
      )}
    </Fragment>
  );

  return (
    <HorizontalToolbar
      style={GetToolbarStyle()}
      leftContent={RenderToolbarContent() ? leftContent : null}
    />
  );
};

export default ContextualToolbarEditBackground;
